module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-image-1-800x533-faba6a0236fb8104c9d8dbf08d497cf1.jpg";